import Question from '../../../components/Question/Question';
import { useMostRecentExamAttempt } from '../../exams';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamQuestion = ({
  trackId,
  onSelectAnswer,
  selectedAnswerIds,
  language
}) => {
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading,
    mostRecentExamAttemptError
  } = useMostRecentExamAttempt(trackId, language);
  const totalQuestionCount = mostRecentExamAttempt ? mostRecentExamAttempt.questions.length : 0;
  const currentQuestionIndex = mostRecentExamAttempt ? Math.max(0, Math.min(mostRecentExamAttempt.questionSubmissions.length, totalQuestionCount - 1)) : 0;
  const currentQuestion = mostRecentExamAttempt && mostRecentExamAttempt.questions[currentQuestionIndex];
  if (mostRecentExamAttemptLoading || mostRecentExamAttemptError || !currentQuestion) return null;
  return /*#__PURE__*/_jsx(Question, {
    answers: currentQuestion.answers,
    id: currentQuestion.id,
    image: currentQuestion.image,
    onSelectAnswer: onSelectAnswer,
    selectedAnswerIds: selectedAnswerIds,
    type: currentQuestion.questionType
  });
};
export default ExamQuestion;